import React, { ChangeEventHandler } from 'react';
import styles from './Input.scss';
import classNames from 'classnames';
import Textarea from 'react-textarea-autosize';
const textAreaMaxLength = 80;

interface InputProps {
  label: string;
  value: string;
  valid: boolean;
  error?: string;
  onBlur(): any;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  dataHook: string;
  type: string;
  autoFocus: boolean;
}

const Input: React.FunctionComponent<InputProps> = ({
  label,
  value,
  valid,
  error,
  onBlur,
  onChange,
  dataHook,
  type,
  autoFocus,
}) => {
  const [count, setCount] = React.useState(0);
  return (
    <div className={styles.container} data-hook={dataHook}>
      <div
        className={classNames({
          [styles.input]: true,
          [styles.dirty]: !!value,
          [styles.invalid]: !valid,
        })}
      >
        {type !== 'message' ? (
          <input
            aria-describedby={`${type}-error`}
            id={type}
            name={type}
            type="text"
            onBlur={onBlur}
            onChange={onChange}
            aria-required={true}
            autoFocus={autoFocus}
          />
        ) : (
          <div>
            {count > 0 && (
              <span className={styles.counter} data-hook={`${type}-counter`}>
                {count}/{textAreaMaxLength}
              </span>
            )}
            <Textarea
              id={type}
              name={type}
              onBlur={onBlur}
              onChange={(e) => {
                setCount(e.target.value.length);
                onChange(e);
              }}
              maxRows={5}
              aria-required={true}
              autoFocus={autoFocus}
              maxLength={textAreaMaxLength}
            />
          </div>
        )}
        <label
          id={`${type}-label`}
          htmlFor={type}
          data-hook="label"
          aria-hidden={true}
        >
          {label}
        </label>
      </div>
      {!valid && (
        <div
          id={`${type}-error`}
          data-hook="error"
          className={styles.error}
          role="alert"
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default Input;
